import { render, staticRenderFns } from "./OwnerList.vue?vue&type=template&id=55225e7e&"
import script from "./OwnerList.vue?vue&type=script&lang=js&"
export * from "./OwnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports